var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import { StartView } from "../Start";
import { LogInView } from "../LogIn";
import { MaintenanceView } from "../Maintenance";
import LocalStorageKeys from "../../classes/LocalStorageKeys";
import { jwtDecode } from "jwt-decode";
import { PreLoadsEmbeddedView, PreloadsIntroView } from "../Preloads";
import { BackgroundVideo } from "../BackgroundVideo";
import { FadeIn, FadeOut } from "../ModalFade";
import { TopBarView } from "../TopBar";
import clientConfig from "../../client.json";
import { DebugLog } from "../../HelperFunctions";
export const IntroView = (props) => {
    const [isStarted, setStarted] = useState(false);
    const [isSignedIn, setSignedIn] = useState(false);
    const [triggerFadeIn, setTriggerFadeIn] = useState(true);
    setTimeout(() => {
        setTriggerFadeIn(false);
    }, 1000);
    class LogInJWT {
        constructor() {
            this.ApplicantId = "";
            this.exp = 0;
        }
    }
    class FailedLoginError {
        constructor() {
            this.status = 0;
            this.path = "";
            this.message = "";
        }
    }
    // const reactPlugin = new ReactPlugin();
    // var appInsights = new ApplicationInsights({
    //   config: {
    //     connectionString:
    //       "InstrumentationKey=f40a8acf-9a54-4ece-86ad-b6c4eb9ba85e;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=387d0a5b-a01c-4b06-a043-ba8207661f99",
    //     extensions: [reactPlugin],
    //   },
    // });
    // appInsights.loadAppInsights();
    // appInsights.trackPageView();
    const [isPointerExitListenerSet, setIsPointerExistListenerSet] = useState(false);
    if (!isPointerExitListenerSet) {
        document.addEventListener("pointerlockchange", () => {
            if (document.pointerLockElement !== null) {
                document.exitPointerLock();
            }
        });
        setIsPointerExistListenerSet(true);
    }
    const cookies = new Cookies();
    const start = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        let loginType = (_a = localStorage.getItem(LocalStorageKeys.loginType)) !== null && _a !== void 0 ? _a : "user";
        if (loginType === "concierge") {
            // concierge login
            try {
                const isLocal = window.location.hostname === "localhost";
                const options = {
                    method: "GET",
                    headers: {
                        "Access-Control-Allow-Headers": "Content-Type",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET",
                        "Content-Type": "text/plain",
                    },
                    params: { toLocal: isLocal, configurator: true },
                    signal: AbortSignal.timeout(10000),
                };
                const url = process.env.REACT_APP_API + "/Login/JD/URL";
                yield axios(url, options)
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    const responseURL = res.data;
                    const statusCode = res.status;
                    if (statusCode === 200) {
                        window.location.href = responseURL;
                        // appInsights.trackEvent({
                        //   name: "Decoded ApplicantId",
                        //   properties: { id: decoded.ApplicantId },
                        // });
                    }
                    else {
                        DebugLog("Error w/ Concierge Login, status code was " + statusCode);
                    }
                }))
                    .catch((error) => {
                    DebugLog("ERROR @ line 447: " + error.message);
                });
            }
            catch (err) {
            }
            return;
        }
        setStarted(true);
        // check if token exists and is fresh
        const gtdToken = cookies.get("user");
        // if token stored in cookies doesn't exist, or has no expiration date, RETURN
        if (gtdToken === null || gtdToken === undefined)
            return;
        const decoded = jwtDecode(gtdToken);
        if (!decoded.exp)
            return;
        // appInsights.trackEvent({
        //   name: "Decoded ApplicantId",
        //   properties: { id: decoded.ApplicantId },
        // });
        const now = Date.now();
        // if token is not expired, sign-in user
        if (decoded.exp * 1000 > now) {
            setSignedIn(true);
            localStorage.setItem(LocalStorageKeys.id, decoded.ApplicantId);
            const vehicleDataExists = yield getVehicleData();
            // Force to include LiquidCarbon option
            localStorage.setItem(LocalStorageKeys.isLiquid, clientConfig.useLiquid ? "aa7QcQ" : "pahsv55");
            setTimeout(() => props.StartLaunch(vehicleDataExists), 1000);
        }
        else {
            cookies.remove("user");
        }
    });
    const getVehicleData = (tokenData = "") => __awaiter(void 0, void 0, void 0, function* () {
        //  revert to old url when fixed
        // const authToken =
        //   cookies.get("user") === undefined ? tokenData : cookies.get("user");
        // const options = {
        //   method: "GET",
        //   headers: {
        //     "Access-Control-Allow-Headers": "Content-Type",
        //     "Access-Control-Allow-Origin": "*",
        //     "Content-Type": "application/json",
        //     Authorization: "Bearer " + authToken,
        //   },
        //   signal: AbortSignal.timeout(10000),
        // };
        // const url = process.env.REACT_APP_API + "/Configurator/Vehicles";
        // await axios(url, options)
        //   .then(async (res) => {
        //     localStorage.setItem(LocalStorageKeys.vehicleDataExists, "false");
        //     DebugLog("**TEST: " + res.status.toString());
        //     if (res.status === 204) {
        //       DebugLog("NO Vehicle Data");
        //       return false;
        //     } else if (res.status === 500 || res.status === 503) {
        //       DebugLog(
        //         "Error in vehicle data collection. Continueing w/ no vehicle data"
        //       );
        //       return false;
        //     }
        //     const data = await res.data;
        //     const vehicleData = data as VehicleData;
        //     if (vehicleData.savedVehicles.length > 0) {
        //       DebugLog("Vehicle Data EXISTS");
        //       localStorage.setItem(LocalStorageKeys.vehicleDataExists, "true");
        //       return true;
        //     }
        //   })
        //   .catch((error) => {
        //     DebugLog("Error in VehicleData_GET");
        //     DebugLog("ErrorMessage: " + error.message);
        //     DebugLog("ErrorCode: " + error.code);
        //     if (error.message == "canceled") {
        //       localStorage.setItem(LocalStorageKeys.vehicleDataExists, "false");
        //       localStorage.removeItem(LocalStorageKeys.seriesSelection);
        //       localStorage.removeItem(LocalStorageKeys.packageSelection);
        //       DebugLog("Data Request Timed Out");
        //     }
        //   });
        let appId;
        if (clientConfig.useStaticID) {
            // forced AppID
            appId = "e9f47cf0-873b-4ca7-935c-c9da21096090";
        }
        else {
            appId = localStorage.getItem(LocalStorageKeys.id);
        }
        let returnValue = false;
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: { _ID_Applicant: appId },
            signal: AbortSignal.timeout(10000),
        };
        const url = "https://17avbi.apps.connect.claris.com/api/webhook/v1/retrieve_profile_fe/catch";
        yield axios(url, options)
            .then((res) => __awaiter(void 0, void 0, void 0, function* () {
            localStorage.setItem(LocalStorageKeys.vehicleDataExists, "false");
            if (res.status === 204) {
                // DebugLog("NO Vehicle Data");
            }
            else if (res.status === 500 || res.status === 503) {
                // DebugLog(
                //   "Error in vehicle data collection. Continueing w/ no vehicle data"
                // );
            }
            else if (res.status === 200) {
                //DebugLog("Vehicle Data Exists");
                // set isLiquid carbon
                // DebugLog("!!!" + JSON.stringify(res.data));
                try {
                    const vehicleResponse = JSON.parse(JSON.stringify(res.data)); // as VehicleResponse;
                    // DebugLog("!!!!: " + vehicleResponse.Iteration_Current);
                    // DebugLog("!!: " + vehicleResponse.Is_Available_Liquid_Carbon);
                    if (vehicleResponse.Is_Available_Liquid_Carbon) {
                        // DebugLog("??True");
                    }
                    else {
                        // DebugLog("??False");
                    }
                    if (vehicleResponse.SavedVehicles.length > 0) {
                        localStorage.setItem(LocalStorageKeys.vehicleDataExists, "true");
                        returnValue = true;
                    }
                    else {
                        //DebugLog("** Less than zero")
                    }
                }
                catch (er) {
                    console.error("Error parsing JSON:", er.message);
                }
            }
            else {
                DebugLog("Unexpected GetVehicleData Response; returned status: " + res.status);
            }
        }))
            .catch((error) => {
            if (error.message === "canceled") {
                localStorage.setItem(LocalStorageKeys.vehicleDataExists, "true");
                localStorage.removeItem(LocalStorageKeys.seriesSelection);
                localStorage.removeItem(LocalStorageKeys.packageSelection);
                DebugLog("Data Request Timed Out");
                returnValue = true;
            }
        });
        return returnValue;
    });
    const postLoginLogic = (tokenData) => __awaiter(void 0, void 0, void 0, function* () {
        DebugLog("postLoginLogic");
        const vehicleDataExists = yield getVehicleData(tokenData);
        DebugLog("PostLoginVehicleData: " + vehicleDataExists);
        setTimeout(() => setSignedIn(true), 800);
        setTimeout(() => props.StartLaunch(vehicleDataExists), 1400);
    });
    const logIn = (u, p) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const userName = u;
        const password = p;
        let logInResult = "";
        let loginType = (_b = localStorage.getItem(LocalStorageKeys.loginType)) !== null && _b !== void 0 ? _b : "user";
        if (loginType === "user") {
            try {
                const jsonRequest = {
                    email: userName,
                    password: password,
                };
                const options = {
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Headers": "Content-Type",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "POST",
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify(jsonRequest),
                    signal: AbortSignal.timeout(10000),
                };
                const url = process.env.REACT_APP_API + "/Login";
                yield axios(url, options)
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    const tokenData = res.data.token;
                    const success = res.data.success;
                    if (success) {
                        const decoded = jwtDecode(tokenData);
                        cookies.set("user", tokenData, {
                            path: "/",
                            sameSite: "strict",
                            secure: false,
                        });
                        // appInsights.trackEvent({
                        //   name: "Decoded ApplicantId",
                        //   properties: { id: decoded.ApplicantId },
                        // });
                        localStorage.setItem(LocalStorageKeys.id, decoded.ApplicantId);
                        localStorage.setItem(LocalStorageKeys.isLiquid, clientConfig.useLiquid ? "aa7QcQ" : "pahsv55");
                        logInResult = success ? "success" : "";
                        // TODO:P remove after testing in staging
                        // clientOptions.ModelId =
                        //   localStorage.getItem(LocalStorageKeys.loginType) === "user"
                        //     ? process.env.REACT_APP_MODEL_ID
                        //     : process.env.REACT_APP_CONCIERGE_MODEL_ID;
                        postLoginLogic(tokenData);
                    }
                    else {
                    }
                }))
                    .catch((error) => {
                    const errorResponse = error.response.data;
                    DebugLog("Error Message" + errorResponse.message);
                    DebugLog("Error Status: " + error.status);
                    DebugLog("Error Path: " + errorResponse.path);
                    if (error.message === "canceled") {
                        DebugLog("Request Timed Out");
                        logInResult = "timeout";
                    }
                    else if (error.status === 515) {
                        // check for different messages here
                        DebugLog("ErrorMessage: " + error.message);
                        switch (errorResponse.message) {
                            case "ERR_LOGIN_INVALID":
                                logInResult = "invalid";
                                break;
                            case "ERR_EMAIL_VERIFICATION":
                                logInResult = "unverified";
                                break;
                            case "ERR_ACCESS_CONFIGURATOR":
                                logInResult = "noAccess";
                                break;
                            default:
                                logInResult = "poo";
                                break;
                        }
                    }
                });
                // .catch((error) => {
                //   if (error.message === "canceled") {
                //     DebugLog("Request Timed Out");
                //     logInResult = "timeout";
                //   }
                // });
                return logInResult;
            }
            catch (err) {
            }
        }
        return logInResult;
    });
    if (clientConfig.isMaintenance) {
        return (_jsxs("div", Object.assign({ style: { height: "100%", display: "flex", justifyContent: "center" } }, { children: [_jsx(TopBarView, { BarSelect: 0 }), _jsx(MaintenanceView, {})] })));
    }
    else {
        return (_jsxs("div", Object.assign({ style: { height: "100%", display: "flex", justifyContent: "center" } }, { children: [_jsx(PreloadsIntroView, {}), _jsx(PreLoadsEmbeddedView, {}), _jsx(BackgroundVideo, {}), triggerFadeIn && _jsx(FadeIn, {}), _jsx(TopBarView, { BarSelect: 0 }), !isStarted && _jsx(StartView, { Start: start }), !isSignedIn && isStarted && _jsx(LogInView, { LogIn: logIn }), isSignedIn && _jsx(FadeOut, {})] })));
    }
};
